import { Validator } from '@vista-digital/validator';
import { MemberBalancePrimaryValue } from './member-balance-primary-value';
export const memberBalanceConfigValidator = Validator.object({
    primaryValue: Validator.oneOf(Object.values(MemberBalancePrimaryValue)),
    showSecondaryValue: Validator.boolean()
});
export const defaultMemberBalanceConfig = {
    primaryValue: MemberBalancePrimaryValue.BalanceUnits,
    showSecondaryValue: true
};
